import React, { useContext } from 'react'
import { Grid, Typography } from '@mui/material';
import { ImageSearchContext } from '../../components/ImageSearchQueryContext';
import { QUERY_PARAMS } from '../../const';

const excludedKeys = ["processedDateTo", "batchAmountTo", "batchNumberTo", "checkNumberTo", "amountTo"];
const numberRangeKeys = ["batchNumberFrom", "batchAmountFrom", "checkNumberFrom", "amountFrom"];

const SearchQueryDetails = () => {
    const { searchQueryContext, screen } = useContext(ImageSearchContext);
    const getDateRange = () => {
        const processedDateFrom = new Date(searchQueryContext['processedDateFrom'])?.toLocaleDateString('en-US');
        const processedDateTo = new Date(searchQueryContext['processedDateTo'])?.toLocaleDateString('en-US');
        return `${processedDateFrom} - ${processedDateTo}`
    }

    const getNumberRange = (paramName) => {
        const fromValue = searchQueryContext[paramName];
        const toValue = searchQueryContext[paramName.replace("From", "To")];
        return `${fromValue} - ${toValue}`
    }
    return <Grid container spacing={3} sx={{ padding: '24px 32px 0px' }}>
        {Object.keys(searchQueryContext)?.map((key) => {
            return searchQueryContext[key] && !excludedKeys.includes(key) && ((screen === 4 && key !== "batchNumberFrom" && key !== "batchNumberTo") || screen !== 4) && <Grid key={key} item size={3}>
                <Grid container flexDirection={'column'}>
                    <Grid item>
                        <Typography sx={{ fontWeight: 600 }}>
                            {key !== 'processedDateFrom' ? QUERY_PARAMS[key] : QUERY_PARAMS["processedDateRange"]}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography>
                            {key === 'processedDateFrom' ? getDateRange() : numberRangeKeys.includes(key) ? getNumberRange(key) :searchQueryContext[key]}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        })}


    </Grid>
}
export default SearchQueryDetails;